import * as React from 'react'
import { VisibilityOutlined } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import { GridActionsCellItem } from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

type ViewProps = {
  participantID: string
}

const ViewParticipant = ({ participantID }: ViewProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <GridActionsCellItem
      key="view"
      icon={
        <Tooltip title={t('common.view')}>
          <VisibilityOutlined fontSize="small" />
        </Tooltip>
      }
      label="View User"
      onClick={() => {
        navigate(`/adm/participant/${participantID}`)
      }}
      data-testid="view-participant"
    />
  )
}

export default ViewParticipant
